import { render, staticRenderFns } from "./sanctionList.vue?vue&type=template&id=59c03f6a&scoped=true"
import script from "./sanctionList.vue?vue&type=script&lang=js"
export * from "./sanctionList.vue?vue&type=script&lang=js"
import style0 from "./sanctionList.vue?vue&type=style&index=0&id=59c03f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c03f6a",
  null
  
)

export default component.exports